import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getSelectedLanguageFromCookie } from '@/utils/utilities';
import enTranslation from '@/public/en/common.json';
import frTranslation from '@/public/fr/common.json';
import deTranslation from '@/public/de/common.json';
import esTranslation from '@/public/es/common.json';
import zhTranslation from '@/public/zh/common.json';
import ptTranslation from '@/public/pt/common.json';
import itTranslation from '@/public/it/common.json';
import koTranslation from '@/public/ko/common.json';
import jaTranslation from '@/public/ja/common.json';
import heTranslation from '@/public/he/common.json';
import hiTranslation from '@/public/hi/common.json';
/**
 * Initialize i18n synchronously with resources
 * i18n configuration with fallback behavior for missing translation keys:
 *
 * 1. If a key is missing in the selected language (e.g., French, German, etc.),
 *    it will automatically fall back to English (fallbackLng: 'en')
 *
 * 2. If the key is also missing in English, it will return the key name itself
 *    and log a warning to the console (parseMissingKeyHandler)
 *
 * Example flow:
 * - User language: French → Key missing in fr/common.json → Falls back to en/common.json → Returns English value
 * - User language: French → Key missing in fr/common.json → Key also missing in en/common.json → Returns the key name
 */
// Resolve initial language via cookie util with navigator fallback
function resolveInitialLanguage() {
    try {
        if (typeof getSelectedLanguageFromCookie === 'function') {
            const fromCookie = getSelectedLanguageFromCookie();
            if (fromCookie &&
                typeof fromCookie === 'string' &&
                fromCookie.trim()) {
                return fromCookie.trim().toLowerCase();
            }
        }
    }
    catch {
        // Ignore errors and fallback below
    }
    // Default fallback language is English
    return 'en';
}
const configuredI18n = i18n.use(initReactI18next);
configuredI18n.init({
    debug: false,
    fallbackLng: 'en',
    lng: resolveInitialLanguage(),
    interpolation: {
        escapeValue: false
    },
    returnNull: false,
    returnEmptyString: false,
    parseMissingKeyHandler: (key) => {
        console.warn(`Missing translation key: ${key}`);
        return key;
    },
    resources: {
        en: {
            translation: enTranslation
        },
        fr: {
            translation: frTranslation
        },
        de: {
            translation: deTranslation
        },
        es: {
            translation: esTranslation
        },
        zh: {
            translation: zhTranslation
        },
        pt: {
            translation: ptTranslation
        },
        it: {
            translation: itTranslation
        },
        ko: {
            translation: koTranslation
        },
        ja: {
            translation: jaTranslation
        },
        he: {
            translation: heTranslation
        },
        hi: {
            translation: hiTranslation
        }
    }
});
export default configuredI18n;
